// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1r6av","title":"ClientReferral_title__o0UoM","itemText":"ClientReferral_itemText__2pck0"};